import axios from "axios";
import { getUserFromSessionStorage } from "../appAuth/auth-provider";

// API Base URLs - will be moved to .env file
const SANDBOX_BASE_URL = process.env.REACT_APP_SANDBOX_API_URL || "https://8u6gr3dn2g.execute-api.us-east-1.amazonaws.com/Dev/";
const DEV_BASE_URL = process.env.REACT_APP_DEV_API_URL || "https://vrzy62aws9-vpce-068a21ad2a050c990.execute-api.us-east-1.amazonaws.com/dev/";
const PROD_BASE_URL = process.env.REACT_APP_PROD_API_URL || "https://h7syscw6ad-vpce-071f556077546152f.execute-api.us-east-1.amazonaws.com/prod/";
const NYU_PORTAL_BASE_URL = process.env.REACT_APP_NYU_PORTAL_API_URL || "https://anypoint.mulesoft.com/exchange/api/v2";

// Create Axios instances
export const SandboxApi = axios.create({
  baseURL: SANDBOX_BASE_URL,
});

export const DevApi = axios.create({
  baseURL: DEV_BASE_URL,
});

export const ProdApi = axios.create({
  baseURL: PROD_BASE_URL,
});

export const NyuPortalApi = axios.create({
  baseURL: NYU_PORTAL_BASE_URL,
});

// DevApiNoAuth - for endpoints that don't require authentication
export const DevApiNoAuth = axios.create({
  baseURL: DEV_BASE_URL,
});

// Centralized Error Handler
export const handleApiError = (error) => {
  // Extract meaningful error message
  const message =
    error.response?.data?.errors?.map(e => e.message).join('\n') ||
    error.response?.data?.message ||
    error.message ||
    'An unexpected error occurred';

  const statusCode = error.response?.status;

  console.error('[API Error]:', {
    message,
    statusCode,
    url: error.config?.url,
    method: error.config?.method,
  });

  // Return a proper Error object for compatibility with existing error handlers
  const apiError = new Error(message);
  apiError.statusCode = statusCode;
  apiError.originalError = error;

  return apiError;
};

// Request Interceptor - Inject auth token automatically
const requestInterceptor = (config) => {
  const user = getUserFromSessionStorage();

  // Ensure headers object exists
  if (!config.headers) {
    config.headers = {};
  }

  if (user?.token) {
    config.headers.authorizationToken = user.token;
  }

  return config;
};

const requestErrorInterceptor = (error) => {
  console.error('[Request Error]:', error);
  return Promise.reject(error);
};

// Response Interceptor - Handle common errors
const responseInterceptor = (response) => {
  return response;
};

const responseErrorInterceptor = (error) => {
  const statusCode = error.response?.status;

  // Handle 401 Unauthorized
  if (statusCode === 401) {
    console.warn('[Auth Error]: Unauthorized access. Session may have expired.');
    // Note: Not implementing auto-logout as per user request
  }

  // Handle 403 Forbidden
  if (statusCode === 403) {
    console.warn('[Auth Error]: Access forbidden.');
  }

  // Handle 500 Server Error
  if (statusCode >= 500) {
    console.error('[Server Error]: Backend service error.');
  }

  return Promise.reject(error);
};

// Apply interceptors to authenticated API instances
[SandboxApi, DevApi, ProdApi].forEach(api => {
  api.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
  api.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
});

// Apply only response interceptor to non-auth instances (no token injection)
[NyuPortalApi, DevApiNoAuth].forEach(api => {
  api.interceptors.response.use(responseInterceptor, responseErrorInterceptor);
});
